import React, { useEffect } from 'react';

import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Services from './pages/Services';
import AboutPage from './pages/AboutPage';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import ProjectDetail from './components/projects/ProjectDetail';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, [pathname]);

  return null;
};

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 60,         // less movement
      easing: "ease-out",
    });
  }, []);

  return (
    <BrowserRouter>
      <div>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/services' element={<Services />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/projects' element={<Projects />} />
           <Route path="/projects/:slug" element={<ProjectDetail />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;